// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"405":"f2eddc0b","715":"c00859df"}[chunkId] + ".chunk.js";
};